<template>
  <el-dialog
    title="Edit Name"
    :visible.sync="show"
    @close="$emit('update:isVisible', false)"
    :close-on-click-modal="false"
  >
    <el-form @keyup.enter.native="handleSubmit">
      <el-form-item label="Name">
        <el-input
          v-model="$v.name.$model"
          :class="{ error: checkValid && $v.name.$invalid }"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="button" @click="handleSubmit">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";

/**
 * @vue-data {Object} [name=this.currentJobName] - Name of the package that is being edited
 * @vue-data {Boolean} [checkValid=false] - Flag that indicates whether to check for errors
 */
export default {
  props: {
    isVisible: Boolean,
  },
  computed: {
    ...mapState(["currentJobName"]),
  },
  watch: {
    isVisible(value) {
      this.show = value;
      if (value) {
        this.name = this.currentJobName;
      } else {
        this.checkValid = false;
      }
    },
  },
  data() {
    return {
      name: this.currentJobName,
      checkValid: false,
      show: this.isVisible,
    };
  },
  methods: {
    /**
     * Submits the updated package information
     * @function
     */
    handleSubmit() {
      this.checkValid = true;
      if (this.$v.name.$invalid) return;
      this.checkValid = false;

      this.$emit("jobSubmitted", this.name);
      this.$emit("update:isVisible", false);
    },
  },
  validations() {
    return {
      name: { required },
    };
  },
};
</script>

<style scoped>
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.cancel-button {
  background-color: #7a7c80;
  color: white;
  border-color: white;
}
.cancel-button:focus {
  background-color: #606266;
  color: white;
  border-color: white;
  outline: none;
}
.cancel-button:hover {
  background-color: #606266;
  color: white;
  border-color: white;
  outline: none;
}
</style>
